export default __webpack_public_path__ + "static/media/success.37eb29e7.svg";